import { FunctionComponent } from 'react';
import { CircularProgress, Typography } from '@mui/material';
import { SpinnerContainer, SpinnerText, spinnerProgressSx } from './styled';

interface Props {
    text?: string;
}

const Spinner: FunctionComponent<Props> = ({
    text = 'Analyzing your request...'
}) => {
    return (
        <SpinnerContainer>
            <CircularProgress size={48} sx={spinnerProgressSx} />
            <Typography sx={SpinnerText}>{text}</Typography>
        </SpinnerContainer>
    );
};

export default Spinner;
